import { offerStatusLabel } from '@/custom/classes/offer_status_labels'

export default {
  getAllStatuses: state => {
    return state.offerStatusesList
  },
  getFilterStatuses: (_, getters) => {
    return [...getters.getGreenList, ...getters.getOrangeList, ...getters.getRedList]
  },
  getPurpleList: state => {
    return state.offerStatusesList.filter(status => status.color == 'purple')
  },
  getGreenList: state => {
    return state.offerStatusesList.filter(status => status.color == 'green')
  },
  getGreenListNames: (_, getters) => {
    return getters.getGreenList.map(status => status.name)
  },
  getOrangeList: state => {
    return state.offerStatusesList.filter(status => status.color == 'orange')
  },
  getRedList: state => {
    return state.offerStatusesList.filter(status => status.color == 'red')
  },
  getRedListNames: (_, getters) => {
    return getters.getRedList.map(status => status.name)
  },
  getDarkRedList: state => {
    return state.offerStatusesList.filter(status => status.color == 'dark_red')
  },
  getDarkRedListNames: (_, getters) => {
    return getters.getDarkRedList.map(status => status.name)
  },
  getWarningsRedList: (_, getters) => {
    const black_list = ['admin_rejected', 'awaiting_admin_later']
    const combinedRedStatuses = [...getters.getRedList, ...getters.getDarkRedList]
    return combinedRedStatuses.filter(status => !black_list.includes(status.name))
  },
  getExpiredAdvancedAllGreenList: (_, getters) => {
    const black_list = ['received_proposal', 'done', 'vesting']
    return getters.getGreenList.filter(status => !black_list.includes(status.name)).map(s => s.name).join(',')
  },
  getRestList: state => {
    return state.offerStatusesList.filter(status => status.color == null)
  },
  getFiltersOptions: (_, getters) => {
    return [
      ...getters.getPurpleList.map(status => ({
        text: `🟣 ${offerStatusLabel(status.name)}`,
        value: status.name
      })),
      ...getters.getGreenList.map(status => ({
        text: `🍏 ${status.name}`,
        value: status.name
      })),
      ...getters.getOrangeList.map(status => ({
        text: `🍊 ${status.name}`,
        value: status.name
      })),
      ...getters.getRedList.map(status => ({
        text: `🔴 ${status.name}`,
        value: status.name
      })),
      ...getters.getDarkRedList.map(status => ({
        text: `🟤 ${status.name}`,
        value: status.name
      }))
    ]
  },
  getAdvancedStatuses: () => {
    return 'company_process,interview,received_proposal'
  },
  getStarStatuses: () => {
    return 'company_process,interview,received_proposal'
  },
  getUsersFilters: () => {
    return [
      'display_default',
      'awaiting_applicant',
      'awaiting_applicant_later',
      'awaiting_company',
      'awaiting_company_sent',
      'applicant_rejected',
      'company_rejected',
      'company_rejected_final',
      'filtered_out',
      'preview'
    ]
  },
  getStatusList: (_, getters) => {
    const black_list = [
      'preview',
      'awaiting_filter',
      'awaiting_applicant_later',
      'company_never_replied',
      'awaiting_admin_later',
      'awaiting_company_later',
      'company_rejected_final',
      // system_strong is set only by the system (BA green recommendation); recruiters
      // decide from it via the quick buttons, they never pick it by hand.
      'system_strong'
    ]
    return getters.getFiltersOptions.filter(status => !black_list.includes(status.value))
  }
}
